var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#030659"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9163 10.8591C18.0766 10.8591 19.1894 11.3023 20.0099 12.0913C20.8303 12.8802 21.2913 13.9502 21.2913 15.0659V19.9738H18.3746V15.0659C18.3746 14.694 18.2209 14.3373 17.9475 14.0744C17.674 13.8114 17.303 13.6636 16.9163 13.6636C16.5295 13.6636 16.1586 13.8114 15.8851 14.0744C15.6116 14.3373 15.4579 14.694 15.4579 15.0659V19.9738H12.5413V15.0659C12.5413 13.9502 13.0022 12.8802 13.8227 12.0913C14.6431 11.3023 15.7559 10.8591 16.9163 10.8591V10.8591Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70813 11.5603H9.6248V19.9738H6.70813V11.5603Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16646 9.45686C8.97188 9.45686 9.6248 8.82905 9.6248 8.0546C9.6248 7.28016 8.97188 6.65234 8.16646 6.65234C7.36105 6.65234 6.70813 7.28016 6.70813 8.0546C6.70813 8.82905 7.36105 9.45686 8.16646 9.45686Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/linkedin-2.e3068ef9b0748a60afe6e1d042c5e407.svg";
export { ForwardRef as ReactComponent };